import PigRegistrationCapacityApi from "@/api/pig-registration/PigRegistrationCapacityApi";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async fetchById(_, {id}) {
      try {
        const response = await PigRegistrationCapacityApi.fetchById(id);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async addOrUpdate({dispatch}, form) {
      try {
        const response = await PigRegistrationCapacityApi.addOrUpdate(form);
        dispatch('NOTIFY_MSG', 'pigRegistration.notification.capacity',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async free(_, form) {
      try {
        const response = await PigRegistrationCapacityApi.free(form);
        return Promise.resolve(response.data);
      } catch(error) {
        return Promise.reject(error);
      }
    }
  }
}
